const state = {
  admintoken: null,
  admin: null,
  isAdminLoggedIn: false,
  isAdmintoken: false
}
const getters = {
  getAdmintoken (state) {
    return state.admintoken
  }
}
const mutations = {
  setAdmintoken (state, admintoken) {
    state.admintoken = admintoken
    state.isAdminLoggedIn = !!(admintoken)
    state.isAdmintoken = !!(admintoken)
  },
  setAdmin (state, admin) {
    state.admin = admin
  },
  logoutAdmin (state) {
    state.admin = null
    state.admintoken = null
    state.isAdminLoggedIn = false
    state.isAdmintoken = false
  }
}
const actions = {
  setAdmintoken ({ commit }, admintoken) {
    commit('setAdmintoken', admintoken)
  },
  setAdmin ({ commit }, admin) {
    commit('setAdmin', admin)
  },
  logoutAdmin ({ commit }) {
    commit('logoutAdmin')
  }
}

export default { state, getters, mutations, actions }
